import {getReadableDayMonthDateFormatForDate, getReadableTimeForDate} from '@Utils/date.util';
import {getUserPremiumLevel} from '@Libraries/user.library';
import {USER_PREMIUM_LEVELS} from '@Utils/user.util';

export const getDateForAIGenerate = (startDate: Date, endDate: Date): string => {
  return `${getReadableDayMonthDateFormatForDate(startDate)} - ${getReadableDayMonthDateFormatForDate(endDate)}`;
};

export const getTimeForAIGenerate = (startDateTime: Date, endDateTime: Date): string => {
  return `${getReadableTimeForDate(startDateTime)} - ${getReadableTimeForDate(endDateTime)}`;
};

export const shouldUpsellUserDescriptionAIGeneration = (): boolean => {
  return getUserPremiumLevel() === USER_PREMIUM_LEVELS.PAYG;
};
